













import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ default: 'name' })
  readonly itemText: string;

  @Prop({ default: 'id' })
  readonly itemValue: string;

  @Prop({ required: true })
  readonly scopeFactory: () => Scope<ApplicationRecord>;

  @Model('input', { type: Array })
  readonly value: ApplicationRecord[];

  get selected() {
    if (!this.value) {
      return [];
    }
    return this.value.map(element => element.id);
  }

  set selected(itemArray) {
    this.$emit(
      'input',
      this.items.filter(item => itemArray.includes(item.id)),
    );
  }

  loading: boolean = false;

  items: ApplicationRecord[] = [];

  async update() {
    try {
      this.loading = true;
      const scope = this.scopeFactory();
      const result = await scope.all();
      this.items = result.data;
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.update();
  }
}
